import * as React from 'react';
import { Redirect } from 'react-router';

import { ServiceLocator } from '../../app/ServiceLocator';
import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { FlowDefinition } from '../../ts/models/ContentDefinitions';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { Favorites } from '../../ts/resources/Favorites';
import { Flows } from '../../ts/resources/Flows';

export interface FlowSpaceFavoriteRedirectProps {
  readonly flowId: string;
  readonly urls: SpacesSiteUrls;
}

type FlowStatus = 'unfetched' | 'fetched' | 'error';

export const FlowSpaceFavoriteRedirect: React.FunctionComponent<FlowSpaceFavoriteRedirectProps> = props => {
  const [ flowStatus, setFlowStatus ] = React.useState<FlowStatus>('unfetched');

  React.useEffect(() => {
    let didCancel = false;

    fetchFlow(props.flowId)
      .then(() => !didCancel && setFlowStatus('fetched'))
      .catch(() => {
        removeFavoriteFlow(props.flowId);
        !didCancel && setFlowStatus('error');
      });

    return () => didCancel = true;
  }, []);

  if (flowStatus === 'unfetched') {
    return null;
  } else if (flowStatus === 'fetched') {
    return <Redirect to={props.urls.flowPath(props.flowId)}/>;
  } else {
    return <RouterError errorType={'flow-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchFlow(flowId: string): Promise<FlowDetailInfo> {
  const flows = ServiceLocator.get<Flows>('Flows');
  return flows.getById(flowId);
}

function removeFavoriteFlow(flowId: string) {
  const favorites = ServiceLocator.get<Favorites>('Favorites');
  favorites.remove(flowId, FlowDefinition.contentType);
}
